/** Azienda gestita attiva (gestore multi azienda): inviata al backend come header X-Azienda. */
const AZIENDA_KEY = "rentri.aziendaId";

export function getAziendaId(): string | null {
  try {
    return localStorage.getItem(AZIENDA_KEY);
  } catch {
    return null;
  }
}

/** Entra in un'azienda: ricarica l'app così tutte le cache ripartono dal nuovo contesto. */
export function enterAzienda(id: string, path = "/") {
  localStorage.setItem(AZIENDA_KEY, id);
  window.location.assign(path);
}

/** Torna all'account del gestore (pagina Le mie aziende). */
export function exitAzienda(path = "/gestore") {
  localStorage.removeItem(AZIENDA_KEY);
  window.location.assign(path);
}

export function clearAziendaSilently() {
  localStorage.removeItem(AZIENDA_KEY);
}
